import { Injectable } from '@angular/core';
import { Http, Headers, URLSearchParams } from '@angular/http';
import { Configuration } from '../../app.constants';
import { AuthenticationService } from './authentication.service';
import { Invoice } from '../../agatextscreens/accounting/invoice';
import { Observable } from 'rxjs/Observable';
import { Branch } from '../../agatextscreens/accounting/branch';
import { Customer } from '../../agatextscreens/accounting/customer';
import { Bank } from '../../agatextscreens/accounting/bank';

@Injectable()
export class InvoiceService {
  private _invoiceUrl = this._configuration.apiUrl + "/v2/invoice";

  constructor(private _http: Http,
    private _configuration: Configuration,
    public _authService: AuthenticationService) { }

  getInvoices(): Observable<Invoice[]> {
    let h = this._authService.getHeaders();

    return this._http.get(this._invoiceUrl + "?min=1", { headers: h, search: null }).map(
      response => {
        let body = response.json();
        let inv: Invoice[];

        if (body['invoices'] == null || !Array.isArray(body['invoices'])) {
          inv = [];
        } else {
          inv = body['invoices'];
        }

        return inv;
      }
    );
  }

  getOneInvoice(invoice_id: string): Observable<Invoice[]> {
    let h = this._authService.getHeaders();
    let s: URLSearchParams = new URLSearchParams();

    s.append('invoice_id', invoice_id);

    return this._http.get(this._invoiceUrl, { headers: h, search: s }).map(
      response => {
        let body = response.json();
        let inv: Invoice[];

        if (body['invoices'] == null || !Array.isArray(body['invoices'])) {
          inv = [];
        } else {
          inv = body['invoices'];
        }

        return inv;
      }
    );
  }

  getOutstandingInvoices(customer_id: string): Observable<Invoice[]> {
    let h: Headers = this._authService.getHeaders();
    let s: URLSearchParams = new URLSearchParams();

    s.append('outstanding', 'true');
    s.append('customer_id', customer_id);

    return this._http.get(this._invoiceUrl, { headers: h, search: s }).map(
      response => {
        let body = response.json();
        let inv: Invoice[];

        if (body['invoices'] == null || !Array.isArray(body['invoices'])) {
          inv = [];
        } else {
          inv = body['invoices'];
        }

        return inv;
      }
    );
  }

  createInvoice(customer_id: number, branch_id: number, invoice_date: string, type: string, total: number, invoice_number?: string, sales_order_id?: number) {
    let h: Headers = this._authService.getHeaders();
    let s: URLSearchParams = new URLSearchParams();

    return this._http.post(this._invoiceUrl,
      {
        customer_id: customer_id,
        branch_id: branch_id,
        sales_order_id: sales_order_id,
        invoice_number: invoice_number,
        invoice_date: invoice_date,
        type: type,
        total: total
      },
      { headers: h, search: s }).map(response => response.json());
  }

  updateInvoice(invoice_id: number, processed: number, cheques: number) {
    let h: Headers = this._authService.getHeaders();
    let s: URLSearchParams = new URLSearchParams();

    return this._http.put(this._invoiceUrl,
      {
        id: invoice_id,
        processed: processed,
        cheques: cheques
      },
      { headers: h, search: s }).map(response => response.json());
  }

  changeInvoiceNumber(invoice_id: number, newNumber: string) {
    let h: Headers = this._authService.getHeaders();
    let s: URLSearchParams = new URLSearchParams();

    return this._http.put(this._invoiceUrl,
      {
        id: invoice_id,
        invoice_number: newNumber
      },
      { headers: h, search: s }).map(response => response.json());
  }

}



// WEBPACK FOOTER //
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/src/app/shared/services/invoice.service.ts